import axios from "axios";
import type { LockerUser } from "Models";
import { config } from "@/config/env";
import type { AppQueryConfig } from "QueryTypes";
import { clubhouseApiHeadersV1, lockerApiHeaders } from "utils/api/apiHelper";

const urls = {
  updateAgUserHandicap(userId: string): string {
    return `${config.apiBaseUrl}/api/users/${userId}/ag-handicap`;
  },
  createLockerUser(): string {
    return `${config.apiBaseUrl}/api/partner/user`;
  },
};

export const makeAgHandicapByUserIdMutation = (
  userId: string,
  body: string,
): AppQueryConfig => ({
  url: urls.updateAgUserHandicap(userId),
  queryKey: `updateAgUserHandicap:${userId}`,
  options: { ...clubhouseApiHeadersV1(), method: "POST" },
  body,
  transform: (responseBody: any) => {
    return responseBody;
  },
});

export const createLockerUser = async (body: LockerUser): Promise<any> => {
  return await axios
    .post<LockerUser>(urls.createLockerUser(), body, {
      ...lockerApiHeaders(),
    })
    .then((res) => {
      return {
        status: res.status,
        data: res.data,
      };
    })
    .catch((error) => {
      return { data: error.response.data.title, status: error.response.status };
    });
};
